import styled from 'styled-components';

interface IStepProps {
  disabled?: boolean;
  activeStep?: boolean;
}

export const Step = styled.div<IStepProps>`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 50%;
  font-weight: bold;
  transition: all 0.35s ease-in-out;
  background-color: ${(props: IStepProps): string =>
    props.activeStep ? 'var(--color-accent)' : 'transparent'};
  border: ${(props: IStepProps): string =>
    !props.disabled
      ? '1.5px solid var(--color-text)'
      : '1.5px solid var(--color-disabled-text)'};
  margin-right: 10px;
  color: ${(props: IStepProps): string =>
    !props.disabled ? 'var(--color-text)' : 'var(--color-disabled-text)'};
`;
